// extracted by mini-css-extract-plugin
export default {"container":"Click6_container__P2vWO","overlay":"Click6_overlay__INn2b","title":"Click6_title__t5ho1","button":"Click6_button__ilE+J","hud":"Click6_hud__j3Js2"};